module.exports = __webpack_public_path__ + "media/directory/profile_button-d3ddc72d.svg";